import { useState } from "react"
import { supabase } from "../../lib/supabaseClient"

export function useLoginForm(onSuccess = () => {}) {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [err, setErr] = useState("")
  const [loading, setLoading] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setErr("")
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    })
    setLoading(false)
    if (error) {
      setErr(error.message)
    } else {
      onSuccess()
    }
  }

  return {
    email,
    setEmail,
    password,
    setPassword,
    err,
    loading,
    submit,
  }
}
